//----------------------------------------------------------------------------------------------
import {RSA} from './RSA'
//----------------------------------------------------------------------------------------------
let rsa = new RSA()
//----------------------------------------------------------------------------------------------
export const getAll = () => rsa.getAll()
//----------------------------------------------------------------------------------------------
export const encrypt = (msg)  => rsa.encrpyt(msg)
//----------------------------------------------------------------------------------------------